var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import CarouselPhotoList from './partials/CarouselPhotoList';
import ProductItemList from './partials/ProductItemList';
import UploadLoader from '../../components/UploadLoader';
import PhotoEditorActions from '../PhotoEditor/PhotoEditorActions';
import PhotoEditor from '../PhotoEditor/PhotoEditor';
import SimplePhotoList from './partials/SimplePhotoList';
import Summary from './partials/Summary';
import Warning from '../../components/Warning';
var mapStateToProps = function (state) { return ({
    cartItem: state.cart.cartItems.item,
    photoEditor: state.photoEditor,
    cartItemEditor: state.cartItemEditor,
}); };
var connector = connect(mapStateToProps, {});
var CartItemEditorPhotos = /** @class */ (function (_super) {
    __extends(CartItemEditorPhotos, _super);
    function CartItemEditorPhotos() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isMinimumPayableWarningVisible: true,
        };
        return _this;
    }
    CartItemEditorPhotos.prototype.render = function () {
        if ('loaded' !== this.props.cartItemEditor.photos.status || 'loaded' !== this.props.cartItemEditor.productItems.status) {
            return null;
        }
        return (React.createElement("div", { className: "c-cart-item-editor-photos" },
            React.createElement(UploadLoader, null),
            this.props.cartItemEditor.productItems.items.length > 1 && (React.createElement("div", { className: "c-cart-item-editor-photos__product-items" },
                React.createElement(ProductItemList, { productItems: this.props.cartItemEditor.productItems.items, selectedProductItem: this.props.cartItemEditor.selectedProductItem, selectedPhoto: this.props.cartItemEditor.selectedPhoto }))),
            React.createElement("div", { className: "c-cart-item-editor-photos__photos" },
                this.renderMinimumPayableWarning(),
                this.renderPhotoList()),
            React.createElement("div", { className: "c-cart-item-editor-photos__summary" },
                React.createElement(Summary, null)),
            'active' === this.props.photoEditor.status && React.createElement(PhotoEditor, null)));
    };
    CartItemEditorPhotos.prototype.renderMinimumPayableWarning = function () {
        var _this = this;
        if (!this.props.cartItem.item) {
            return null;
        }
        if (this.props.cartItem.item.product.minimum_payable <= this.props.cartItem.item.photos.length) {
            return null;
        }
        if (!this.state.isMinimumPayableWarningVisible) {
            return null;
        }
        return (React.createElement("div", { className: "c-cart-item-editor-photos__minimum-payable-warning" },
            React.createElement(Warning, { title: "cart_item_editor.minimum_payable_warning", titleParams: { minimum: this.props.cartItem.item.product.minimum_payable }, disableIcon: true, modifier: ['pink-400'], closeHandler: function () {
                    _this.setState({ isMinimumPayableWarningVisible: false });
                } })));
    };
    CartItemEditorPhotos.prototype.renderPhotoList = function () {
        if (!this.props.cartItem.item) {
            return null;
        }
        if (3 === this.props.cartItem.item.product_id) {
            return React.createElement(SimplePhotoList, { cartItem: this.props.cartItem.item, photos: this.props.cartItemEditor.photos.items, selectedPhoto: this.props.cartItemEditor.selectedPhoto });
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(CarouselPhotoList, { photos: this.props.cartItemEditor.photos.items, selectedPhoto: this.props.cartItemEditor.selectedPhoto }),
            React.createElement(PhotoEditorActions, { cartItem: this.props.cartItem.item, photos: this.props.cartItemEditor.photos.items, selectedPhoto: this.props.cartItemEditor.selectedPhoto })));
    };
    return CartItemEditorPhotos;
}(React.Component));
export default connector(CartItemEditorPhotos);
